import script from "./Privacy-Policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacy-Policy.vue?vue&type=script&setup=true&lang=js"

import "./Privacy-Policy.vue?vue&type=style&index=0&id=651bf7a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-651bf7a0"]])

export default __exports__